import React from 'react';

import KPTextform from '../../../../components/KPTComponents/KPTextform';
import { SOLUTIONS_CONSTANTS, FORM_CONSTANTS } from '../../../../constants';
import { Typography } from '@material-ui/core';

export const solutionForm = (values, mobileMode, disabled, typeOptions=SOLUTIONS_CONSTANTS.TYPE_OPTIONS, issueAtLabel='Ngày cấp') => ([
  { key: 'title', width: 12, height: 1, label: 'Tên sáng chế/giải pháp', value: values?.title, disabled, required: true },
  // NSKH 2026: bổ sung thông tin tác giả cho Bằng độc quyền sáng chế/Giải pháp hữu ích
  { key: 'numberMain', width: 6, type: 'int', min: 0, label: 'Số lượng tác giả chính (Tác giả đầu, tác giả liên hệ)', value: values?.numberMain, disabled, required: true },
  { key: 'numberAuthor', width: 6, type: 'int', min: 0, label: 'Số lượng tác giả', value: values?.numberAuthor, disabled, required: true },
  { key: 'author', width: 12, height: 1, label: 'Danh sách tác giả', value: values?.author, disabled, required: true},
  { key: 'role', width: 12, label: 'Vai trò', value: values?.role, options: FORM_CONSTANTS.ROLE_OPTIONS.slice(0, 2), disabled, required: true },
  { key: 'issueBy', width: 12, height: 1, label: 'Nơi cấp', value: values?.issueBy, disabled, required: true },
  { key: 'issueAt', width: 5, label: issueAtLabel, type: 'date', value: values?.issueAt, disabled, required: true },
  { key: 'type', width: 7, label: 'Phân loại', value: values?.type, options: typeOptions, disabled, required: true },
  {
    key: 'previewFile',
    disabled,
    required: true,
    width: 12,
    type: 'file',
    value: values?.previewFile,
    label: (
      <>
        <Typography variant='body1' style={{ fontSize: 17 }}>
          <b>Upload file minh chứng tại đây</b>
        </Typography>
        <Typography variant='body2' color='secondary'>
          Hình ảnh/ file PDF bằng hoặc quyết định được cấp
        </Typography>
        <Typography variant='body2' color='secondary'>
          (Có dấu xác nhận của cơ quan có thẩm quyền)
        </Typography>
      </>
    ),
    acceptedFiles: ["image/*", "application/pdf"],
  },
]);

export default function SangCheForm(props) {
  const textForm = solutionForm(props.values, null, props.disabled);
  return <KPTextform {...props} textForm={textForm} />;
}
